import React, { useEffect, useMemo, useState } from "react";
import ReactTable from "../../components/common/ReactTable";
import { Box, Typography, TextField, alertTitleClasses, Button } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ApiCallService from "../../Service/ApiCallService";
import extractUserFromLocalStorage from "../../Service/jwtUtils";
import { message } from "antd";

import Spinner from "../../components/common/Spinner";
const formatDateTime = (value) => {
	if (!value) return "-";

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "-";

	return new Intl.DateTimeFormat("en-GB", {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: true,
		timeZone: "Asia/Kolkata",
	})
		.format(date)
		.replace(/\b(am|pm)\b/i, (match) => match.toUpperCase());
};

const getHeadName = (user) => {
	if (!user) return "-";
	if (user.fullName) return user.fullName;

	return [user.userFirstName, user.userMiddleName, user.userLastName]
		.filter(Boolean)
		.join(" ") || "-";
};

const AdminDashboard = () => {
	const [loading, setLoading] = useState(false);
	const [interests, setInterests] = useState([]);
	const [search, setSearch] = useState("");
	const userDetails = useSelector((state) => state.user?.userDetails);
	const tokenUser = extractUserFromLocalStorage();
	const userRole = userDetails?.userRole || tokenUser?.userRole;
	// const canViewDashboard = ["Admin", "SuperAdmin", "SuperUser"].includes(userRole);
	const navigate = useNavigate()
	useEffect(() => {
		fetchInterests();
	}, []);




const fetchInterests = async () => {

			try {

				setLoading(true);
				const res = await ApiCallService.get(`${process.env.REACT_APP_BASE_URL}/program-interests`);
				setInterests(res?.data);
			} catch (err) {
				console.error("Program interest fetch error:", err);
				message.error("Failed to fetch program interests.");
			} finally {
				setLoading(false);
			}
		};


	const rows = useMemo(() => {
		const searchTerm = search.trim().toLowerCase();
		return interests
			.map((interest) => {
				const chapterId = interest?.chapterId?._id
				const chapterName = interest?.chapterId?.chapterName || "-";
const districtName =
  interest?.chapterId?.location?.district?.districtName;

const stateName =
  interest?.chapterId?.location?.state?.stateName;

const chapterLocation =
  districtName && stateName
    ? `${districtName}, ${stateName}`
    : stateName
    ? stateName
    : districtName
    ? districtName
    : "-";		
  const headName = getHeadName(interest?.userId);
				const programName = interest?.programName || "-";
				return {
					_id: interest?._id,
					chapterId,
					chapterName,
					chapterLocation,
					headName,
					contactNo: interest?.userId?.mobileNumber || "-",	
					programName,
					createdAt: interest?.createdAt,
					createdDateTime: formatDateTime(interest?.createdAt),
				};
			})
			.filter((row) => {
				if (!searchTerm) return true;

				return [row.chapterName, row.headName, row.programName]
					.join(" ")
					.toLowerCase()
					.includes(searchTerm);
			});
	}, [interests, search]);

	const tableColumns = [
		{
			field: "chapterName",
			headerName: "Chapter Name",
		},
		{
			field: "chapterLocation",
			headerName: "Chapter Location",
		},
		{
			field: "headName",
			headerName: "Name",
		},
		{
			field: "contactNo",
			headerName: "Contact Number",
		},
		{
			field: "programName",
			headerName: "Program Name",
		},
		{
			field: "createdAt",
			headerName: "Created Date & Time",
			renderCell: (row) => row.createdDateTime,
			searchKey: (row) => row.createdDateTime,
		},
		// {
		// 	field: "action",
		// 	headerName: "Action",
		// 	renderCell: (row) => (
		// 		<Button
		// 		disabled={!row?.chapterId}	
		// 			variant="outlined"
		// 			size="small"
		// 			onClick={() => {
		// 				row?.chapterId ?
		// 				navigate(`/dastakChapterView/${row?.chapterId}`) : alert("Chapter Not Found")
		// 			}
		// 			}
		// 		>
		// 			View
		// 		</Button>
		// 	),
		// },
	];

	// if (!canViewDashboard) {
	//	return <Navigate to="/403" replace />;
	// }

	return (
		<Box sx={{ p: 3 }}>
			<Spinner loading={loading} />
			<Box sx={{ display: "flex", flexDirection: "row", alignContent: "center" }}>
				<Typography variant="h4" fontWeight={700} sx={{
					fontSize: {
						xs: "1.05rem",
						sm: "1.5rem",
						md: "2rem",
					},
				}}>
					Program Interest Dashboard
				</Typography>
			</Box>

			<Box sx={{ display: "flex", flexDirection: "row", gap: 2, my: 3 }}>
				<TextField
					placeholder="Search by Chapter, Head, or Program"
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					sx={{ minWidth: 340 }}
				/>
			</Box>

			<ReactTable
				rowKey="_id"
				columns={tableColumns}
				rows={rows}
				loading={loading}
				initialOrderBy="createdAt"
				initialOrder="desc"
				initialRowsPerPage={10}
			/>
		</Box>
	);
};

export default AdminDashboard;
